
export default {
  data() {
    return {
      options: [
        { id: "import", label: "Import Menu" },
        { id: "export", label: "Export Menu" }
      ]
    };
  }
};
